import { ReportFilterType, ShapeDictionaryType } from '../../utils';
import { getReportParams } from '../CreateReportTemplate/getReportParams';
import {
  buildReportFormModel,
  BuildReportFormModelOptions,
  ReportFormModel,
} from './reportFormModel';

export interface ReportSubmissionResult {
  params: ReturnType<typeof getReportParams>;
  reportTemplateName: string;
  reportName: string;
  dateRange: { from: Date; to: Date };
  miscellaneous: Record<string, unknown>;
  shapeDictionary: ShapeDictionaryType;
  filter: ReportFilterType | null;
  model: ReportFormModel;
}

export type BuildReportSubmissionOptions = BuildReportFormModelOptions;

export function buildReportSubmissionFromModel(
  model: ReportFormModel,
): ReportSubmissionResult | null {
  const params = getReportParams(
    model.reportType,
    model.reportTemplateName,
    model.reportName,
    model.shapeDictionary,
    model.dateRange.from,
    model.dateRange.to,
    model.miscellaneous,
    model.filter,
    model.reportTemplateId ?? undefined,
    model.shapeType,
    model.ships ?? [],
    model.shipAttribute,
  );

  if (!params) {
    return null;
  }

  return {
    params,
    reportTemplateName: model.reportTemplateName,
    reportName: model.reportName,
    dateRange: model.dateRange,
    miscellaneous: model.miscellaneous,
    shapeDictionary: model.shapeDictionary,
    filter: model.filter,
    model,
  };
}

export function buildReportSubmission(
  options: BuildReportSubmissionOptions,
): ReportSubmissionResult | null {
  const model = buildReportFormModel(options);

  if (!model) {
    return null;
  }

  return buildReportSubmissionFromModel(model);
}
